import '../css/App.css';
import '../css/outcome.css';
import React, { useState, useEffect }from'react';
import { Grid, Box, Paper, Typography, Button, Alert } from  '@mui/material';
import PatientDetails from '../components/outcomePage/patientDetails';
import ListItem from '../components/outcomePage/listItem';
import QuestionBlock from '../components/outcomePage/questionblock';
import ReferralPathQuestions from '../components/outcomePage/referralpathquestions';
import dispatch from '../utilities/outcomeUtilities/dispatch';

function Outcome(props) {
const [outcome , setOutcome] = useState(props.outcomeData)
console.log(outcome)
let clinicsToRefer={}
for (let clinicType in outcome.clinics)
    {
    clinicsToRefer[clinicType]= outcome.clinics[clinicType].map((eachClinic, key)=><ListItem item={eachClinic} key={key} />)
    }

let investigationsForDisplay = {}
for (let investigationType in outcome.investigations)
    {
    investigationsForDisplay[investigationType] = outcome.investigations[investigationType].map((eachInvestigation, key)=><ListItem item={eachInvestigation} key={key} />)
    }

const printFunction=()=>{window.print()}

async function dispatchFunction()
    {
    let response= await dispatch(outcome)   
    console.log(response)
    }


useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

return (<Box margin={2} >

<Alert sx={{ mb: 1 }} severity='warning'>Section under Development</Alert>
<Grid container>

    <Grid item marginBottom={2} xs={12} >
    <Paper elevation={5}>
    <Typography variant='h4'>
    Patient Details
    </Typography>
    <Box className="outcomeBox">
    <PatientDetails/>
    </Box>
    </Paper>
    </Grid>


    <Grid item xs={12} >
    <Grid container marginBottom={2} spacing={2}>
    </Grid></Grid>

    <Grid item xs={12}>

        <Grid container marginBottom={2} spacing={2}>

            <Grid item xs ={12} sm={6}>
            <Paper elevation={5}>
            <Typography variant='h4'>
             RDC ( 2week rule) Clinics
            </Typography>
            <Box className="outcomeBox">
            {clinicsToRefer["rdc"]}
            </Box>
            </Paper>
            </Grid>

            <Grid item xs={12} sm={6}>
            <Paper elevation={5}>
            <Typography variant='h4'>
                Non RDC Clinics
            </Typography>
            <Box className="outcomeBox">
            {clinicsToRefer["nonRdc"]}
            </Box>
            </Paper>
            </Grid>
        </Grid>
    </Grid>

    <Grid item xs={12}>
    <Grid container marginBottom={2} spacing={2}>

        <Grid item xs ={12} sm={4} className={(investigationsForDisplay["blood"].length > 0 ? "outcomeBlock" : "hidden")}>
        <Paper elevation={5}>
        <Typography variant='h4'>
        Bloods Tests
        </Typography>
        <Box className="outcomeBox">
        {investigationsForDisplay["blood"]}
        </Box>
        </Paper>
        </Grid>

        <Grid item xs ={12} sm={4}className={(investigationsForDisplay["urine"].length > 0 ? "outcomeBlock" : "hidden")}>
        <Paper elevation={5}>
        <Typography variant='h4'>
      Urine Tests
        </Typography>
        <Box className="outcomeBox">
        {investigationsForDisplay["urine"]}
        </Box>
        </Paper>
        </Grid>

        <Grid item xs ={12} sm={4} className={(investigationsForDisplay["stool"].length > 0 ? "outcomeBlock" : "hidden")}>
        <Paper elevation={5}>
        <Typography variant='h4'>
        Stool Tests
        </Typography>
        <Box className="outcomeBox">
        {investigationsForDisplay["stool"]}
        </Box>
        </Paper>
        </Grid>

        <Grid item xs={12} sm={4} className={(investigationsForDisplay["imaging"].length > 0 ? "outcomeBlock" : "hidden")}>
        <Paper elevation={5}>
        <Typography variant='h4'>
        Radiology
        </Typography>
        <Box className="outcomeBox">
        {investigationsForDisplay["imaging"]}
        </Box>
        </Paper>
        </Grid>

        <Grid item xs={12} sm={4} className={(investigationsForDisplay["endoscopy"].length > 0 ? "outcomeBlock" : "hidden")}>
        <Paper elevation={5}>
        <Typography variant='h4'>
        Endoscopy
        </Typography>
        <Box className="outcomeBox">
        {investigationsForDisplay["endoscopy"]}
        </Box>
        </Paper>
        </Grid>

    </Grid>

    <Grid item xs={12}>
    <Paper elevation={5}>
    <Typography variant='h4'>
    Clinical History
    </Typography>
    <Box className="outcomeBox">
    <span> {outcome.story}</span>
    </Box>
    </Paper>
    </Grid>
    

    <Grid item xs={12} >
    <Grid container marginBottom={2} spacing={2}>
    <Grid item xs={12} sm={4} className={(clinicsToRefer.rdc.length>0 ? "outcomeBlock" : "hidden")}>
        <Paper elevation={5}>
        <Typography variant='h4'>
        RDC Referral Information
        </Typography>
        
       < QuestionBlock paths= {outcome.clinicInfo.rdc}/>
        
        </Paper>
        </Grid>

        <Grid item xs={12} sm={4} className={(clinicsToRefer.nonRdc.length>0 ? "outcomeBlock" : "hidden")}>
        <Paper elevation={5}>
        <Typography variant='h4'>
        Non RDC Referral Information
        </Typography>
       < QuestionBlock paths= {outcome.clinicInfo.nonRdc}/>
        </Paper>
        </Grid>


        <Grid item xs={12} sm={4} className={(outcome.investigationRequestInformation !== undefined ? "outcomeBlock" : "hidden")}>
        <Paper elevation={5}>
        <Typography variant='h4'>
        Investigation Order Information
        </Typography>
        <Box className="outcomeBox">
       < ReferralPathQuestions questions = {outcome.investigationRequestInformation}/>
        </Box>
        </Paper>
        </Grid>
</Grid>
</Grid>
</Grid>
</Grid>
    <Button variant='contained' onClick = {dispatchFunction} sx={{marginRight:4}}>Submit to e-referrals</Button>
    <Button variant='contained' onClick={printFunction}>Print Outcome </Button>
    </Box>)
}

export default Outcome;